export const hotjarAppId = process.env.HOTJAR_ID || 3437852;

export const hotjarAppVersion = process.env.HOTJAR_VERSION || 6;
